module.exports = __webpack_public_path__ + "img/rsrch_terraformers.png.0abf660.png";